const appConfig = window.__APP_CONFIG__ || {}

export const getApiUrl = () => appConfig.VUE_APP_API_URL || ''
export const getMerchantPortalUrl = () => appConfig.VUE_APP_MERCHANT_PORTAL_URL || ''
export const getIdleTimeoutSeconds = () => appConfig.VUE_APP_IDLE_TIMEOUT_SECONDS || 600

// external links
export const getStartedUrl = () => appConfig.VUE_APP_STARTED_URL || ''
export const getAboutUrl = () => appConfig.VUE_APP_ABOUT_URL || ''
export const getContactUsUrl = () => appConfig.VUE_APP_CONTACT_US_URL || ''
